<div class="agpr-canvasChart">
    @if (data?.chart?.generateOnSend) {
        <div class="agpr-canvasChart-watermark">
            {{ 'Reports.chart.dataSendTime' | localize }}
        </div>
    }

    <div
        class="agpr-canvasChart-container"
        [ngStyle]="{
            'display': 'flex',
            'justify-content': data?.styles?.imageAlignment
        }"
    >
        <div
            class="agpr-canvasChart-chart"
            [ngStyle]="{
                'height': data?.displaySize + 'px',
                'width': data?.widthPercent + '%',
                'border-width': (data?.styles?.doBorder ? data?.styles?.borderWidth : 0) + 'px',
                'border-style': 'solid',
                'border-color': data?.styles?.borderColor,
                'background-color': data?.styles?.backgroundColor,
                'padding-top': data?.styles?.padding.paddingOption
                    ? (data?.styles?.padding.topPadding) + 'px'
                    : (data?.styles?.padding.paddingAll) + 'px',
                'padding-right': data?.styles?.padding.paddingOption
                    ? (data?.styles?.padding.rightPadding) + 'px'
                    : (data?.styles?.padding.paddingAll) + 'px',
                'padding-bottom': data?.styles?.padding.paddingOption
                    ? (data?.styles?.padding.bottomPadding) + 'px'
                    : (data?.styles?.padding.paddingAll) + 'px',
                'padding-left': data?.styles?.padding.paddingOption
                    ? (data?.styles?.padding.leftPadding) + 'px'
                    : (data?.styles?.padding.paddingAll) + 'px',
                'border-top-left-radius': data?.styles?.cornerRadius?.cornerRadiusOption
                    ? (data?.styles?.cornerRadius.topLeftCornerRadius) + 'px'
                    : (data?.styles?.cornerRadius?.cornerRadiusAll || 0) + 'px',
                'border-top-right-radius': data?.styles?.cornerRadius?.cornerRadiusOption
                    ? (data?.styles?.cornerRadius.topRightCornerRadius) + 'px'
                    : (data?.styles?.cornerRadius?.cornerRadiusAll || 0) + 'px',
                'border-bottom-left-radius': data?.styles?.cornerRadius?.cornerRadiusOption
                    ? (data?.styles?.cornerRadius.bottomLeftCornerRadius) + 'px'
                    : (data?.styles?.cornerRadius?.cornerRadiusAll || 0) + 'px',
                'border-bottom-right-radius': data?.styles?.cornerRadius?.cornerRadiusOption
                    ? (data?.styles?.cornerRadius.bottomRightCornerRadius) + 'px'
                    : (data?.styles?.cornerRadius?.cornerRadiusAll || 0) + 'px'
            }"
        >
            @if (data?.chartBlock) {
                @if (type === reportBlockTypeEnum.COVERAGE_SUMMARY) {
                    <div
                        class="agpr-canvasChart-coverageSummaryChart"
                    >
                        @if(data?.chartBlock.displayElement?.chartHeaderSettings?.title
                        || data?.chartBlock.displayElement?.chartHeaderSettings?.dateRange
                        || data?.chartBlock.displayElement?.chartHeaderSettings?.sourceLink ) {
                            <div class="agpr-canvasChart-metadata agpr-canvasChart-coverageSummaryChart-metadata">
                                @if (data?.chartBlock.displayElement?.chartHeaderSettings?.title) {
                                    <div class="agpr-canvasChart-metadata-title">
                                        <label tabindex="0">{{ data?.chartBlock.displayElement?.title }}</label>
                                    </div>
                                }
                                @if (data?.chartBlock.displayElement?.chartHeaderSettings?.dateRange || data?.chartBlock.displayElement?.chartHeaderSettings?.sourceLink) {
                                    <div class="agpr-canvasChart-metadata-subtitleGroup">
                                        @if (data?.chartBlock.displayElement?.chartHeaderSettings?.dateRange) {
                                            <label
                                                id="canvasChart_coverageSummaryChart_dateRange"
                                                class="agpr-canvasChart-metadata-dateRange"
                                                [pTooltip]="data?.chartBlock.displayElement?.dateRangeLabel"
                                                tooltipPosition="bottom"
                                                tabindex="0"
                                            >
                                                {{ data?.chartBlock.displayElement?.dateRangeLabel }}
                                            </label>
                                        }

                                        @if (data?.chartBlock.displayElement?.chartHeaderSettings?.sourceLink) {
                                            <span
                                                class="agpr-canvasChart-metadata-source"
                                                [ngClass]="{'noDate': !data?.chartBlock.displayElement?.chartHeaderSettings?.dateRange}"
                                                [pTooltip]="nonAmChartSeries && nonAmChartSeries[0] ? nonAmChartSeries[0].label : ''"
                                                tooltipPosition="bottom"
                                                [attr.tabindex]="(nonAmChartSeries && nonAmChartSeries[0] && nonAmChartSeries[0].label) ? '0' : '-1'"
                                            >
                                                {{ nonAmChartSeries && nonAmChartSeries[0] ? nonAmChartSeries[0].label : '' }}
                                            </span>
                                        }
                                    </div>
                                }
                            </div>
                        }
                        <div class="agpr-canvasChart-coverageSummaryChart-container">
                            @if (nonAmChartSeries) {
                                <agpr-data-list-chart
                                    [responsive]="true"
                                    [block]="data?.chartBlock"
                                    [series]="nonAmChartSeries"
                                    [colors]="data?.chartBlock.displayElement?.styles?.colorMap"
                                    [chartOptions]="dataListChartOptions"
                                    (dataChange)="changeDetectorRef.detectChanges()"
                                ></agpr-data-list-chart>
                            } @else {
                                <div class="agpr-canvasChart-noChartMessage">
                                    <agpr-message
                                        [id]="id + '_dataSource_error'"
                                        [severity]="messageSeverityEnum.info"
                                    >
                                        {{ 'Reports.chart.noDataSource' | localize }}
                                    </agpr-message>
                                </div>
                            }
                        </div>
                    </div>
                } @else if (type === reportBlockTypeEnum.TOP_TERMS && data?.chartBlock.displayElement.chartSpecificType === chartSpecificTypesEnum.CARD_LIST) {
                    <div
                        class="agpr-canvasChart-topTermChart-container"
                    >
                        @if (data?.chartBlock.displayElement?.chartHeaderSettings?.title
                        || data?.chartBlock.displayElement?.chartHeaderSettings?.dateRange
                        || data?.chartBlock.displayElement?.chartHeaderSettings?.sourceLink ) {
                            <div class="agpr-canvasChart-metadata agpr-canvasChart-coverageSummaryChart-metadata">
                                @if (data?.chartBlock.displayElement?.chartHeaderSettings?.title) {
                                    <div class="agpr-canvasChart-metadata-title">
                                        <label tabindex="0">{{ data?.chartBlock.displayElement?.title }}</label>
                                    </div>
                                }
                                @if (data?.chartBlock.displayElement?.chartHeaderSettings?.dateRange || data?.chartBlock.displayElement?.chartHeaderSettings?.sourceLink) {
                                    <div class="agpr-canvasChart-metadata-subtitleGroup">
                                        @if (data?.chartBlock.displayElement?.chartHeaderSettings?.dateRange) {
                                            <label
                                                id="canvasChart_coverageSummaryChart_dateRange"
                                                class="agpr-canvasChart-metadata-dateRange"
                                                [pTooltip]="data?.chartBlock.displayElement?.dateRangeLabel"
                                                tooltipPosition="bottom"
                                                tabindex="0"
                                            >
                                                {{ data?.chartBlock.displayElement?.dateRangeLabel }}
                                            </label>
                                        }

                                        @if (data?.chartBlock.displayElement?.chartHeaderSettings?.sourceLink) {
                                            <span
                                                class="agpr-canvasChart-metadata-source"
                                                [ngClass]="{'noDate': !data?.chartBlock.displayElement?.chartHeaderSettings?.dateRange}"
                                                [pTooltip]="nonAmChartSeries && nonAmChartSeries[0] ? nonAmChartSeries[0].label : ''"
                                                tooltipPosition="bottom"
                                                [attr.tabindex]="(nonAmChartSeries && nonAmChartSeries[0] && nonAmChartSeries[0].label) ? '0' : '-1'"
                                            >
                                                {{ nonAmChartSeries && nonAmChartSeries[0] ? nonAmChartSeries[0].label : '' }}
                                            </span>
                                        }
                                    </div>
                                }
                            </div>
                        }
                        <div class="agpr-canvasChart-topTermChart-chart">
                            @if (nonAmChartSeries) {
                                <agpr-scroll-panel>
                                    <agpr-top-terms-chart
                                        [series]="nonAmChartSeries"
                                        [numOfItems]="data?.chartBlock.displayElement.numOfItems"
                                        [focusable]="false"
                                        [chartOptions]="topTermChartOptions"
                                        [noContentMessage]="'Common.noContentToDisplay' | localize"
                                        [accentColor]="data?.accentColor"
                                        [hideViewPostsLink]="true"
                                        (dataChange)="changeDetectorRef.detectChanges()"
                                    ></agpr-top-terms-chart>
                                </agpr-scroll-panel>
                            } @else {
                                <agpr-message
                                    class="agpr-chartBlock-noChartMessage"
                                    [id]="id + '_dataSource_error'"
                                    [severity]="messageSeverityEnum.error"
                                >
                                    {{ 'Reports.error.folderRemoved' | localize }}
                                </agpr-message>
                            }
                        </div>
                    </div>
                } @else if (
                    (type === reportBlockTypeEnum.TOP_10_OUTLETS
                    || type === reportBlockTypeEnum.TOP_10_AUTHORS_BY_VOLUME)
                    && data?.chartBlock.displayElement?.chartHeaderSettings.entityProfile
                ) {
                    @if (nonAmChartSeries?.[0]) {
                        <agpr-top-entities-chart
                            [displayElement]="data?.chartBlock.displayElement"
                            [series]="nonAmChartSeries[0]"
                            [entityType]="data?.chartBlock?.type?.key === reportBlockTypeEnum.TOP_10_OUTLETS ? entityTypes.OUTLET : entityTypes.CONTACT"
                            [width]="width"
                            [height]="height"
                            [accentColor]="data?.accentColor"
                            [disableViewMentionLink]="true"
                        ></agpr-top-entities-chart>
                    }
                } @else if (type === reportBlockTypeEnum.COVERAGE_METRIC) {
                    <agpr-coverage-metric-chart
                        [displayElement]="data?.chartBlock.displayElement"
                        [series]="nonAmChartSeries?.[0]"
                        [accentColor]="data?.chartBlock.displayElement?.styles?.colorMap['accentColor']"
                        [dateRangeLabelOverride]="useDisplayElementDateRangeLabel ? data?.chartBlock.displayElement?.dateRangeLabel : null"
                        (dataChange)="changeDetectorRef.detectChanges()"
                    ></agpr-coverage-metric-chart>
                } @else {
                    @if (am5BlockTypes.includes(type)) {
                        <agpr-am5-chart
                            #am5ChartComponent
                            [chart]="am5Chart"
                            [series]="reportSeries"
                            (noData)="updateNoData($event)"
                        ></agpr-am5-chart>
                    } @else {
                        <agpr-reports-chart
                            [chart]="chart"
                            [disableViewMentionLink]="true"
                            (noData)="updateNoData($event)"
                        ></agpr-reports-chart>
                    }
                }
            }
        </div>
    </div>

    @if (data?.caption) {
        <div
            class="agpr-canvasChart-caption"
            [ngStyle]="{
                'text-align': data?.styles?.alignment,
                'font-weight': data?.styles?.bold ? 'bold' : 'normal',
                'color': data?.styles?.color,
                'font-family': data?.styles?.fontFamily,
                'font-size': data?.styles?.fontSize,
                'font-style': data?.styles?.italics ? 'italic' : 'normal',
                'text-decoration': data?.styles?.underlined ? 'underline' : 'none',
                'display': 'block',
                'line-height': '100%'
            }"
        >
            {{ data?.caption }}
        </div>
    }
</div>